import { render } from "./TextForm.vue?vue&type=template&id=3a2c373c&scoped=true"
import script from "./TextForm.vue?vue&type=script&lang=js"
export * from "./TextForm.vue?vue&type=script&lang=js"

import "./TextForm.vue?vue&type=style&index=0&id=3a2c373c&scoped=true&lang=css"

import exportComponent from "D:\\Coding\\welikethespeech\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a2c373c"]])

export default __exports__